import React, { Component, useDebugValue } from 'react';
import { Link } from 'react-router';
import { Row, Col } from 'reactstrap';
import { leaseTypeDrpdwn } from '../../../../constants';
import {checkString} from '../../../../formValidator'
import { jetStreamInstance } from '../../../Leases';
import { FieldCol, FieldDate, FieldGroup, FieldInput, FieldLabel, FieldSelect, FieldTextarea } from '../../../../applications/contracts/Elements';
export default class EditDeliveryCndCard extends Component{
  constructor(props){
    super(props);
    this.state = {
      deliveryCndCard: {},
      error: {}
    }
  }
  componentDidMount(){
    this.updateHdState(this.props.deliveryCndCard);
  }
  updateHdState = (deliveryCndCard) => {
    let data = Object.assign({}, deliveryCndCard);
    this.setState({
        deliveryCndCard: data
    });
  }
  updateForm = (type, value) => {
    if(['delivery_location','actual_delivery_date','delivery_comment'].includes(type)){
      this.setState(prevState => ({
        deliveryCndCard: {
          ...prevState.deliveryCndCard,
          titan_extra_fields: {
            ...prevState.deliveryCndCard?.titan_extra_fields,
            [type]: value,
          },
        },
      }));
    }
  }
  updateDeliveryCndCard = (e) => {
    e.preventDefault();
    const titan_extra_fields = { ...this.state.deliveryCndCard.titan_extra_fields };
    this.props.updateDeliveryCndCard({ titan_extra_fields })
  }
  render(){
    const { type} = this.props;
    const { deliveryCndCard } = this.state;
      return(
        <form onSubmit={(e) => this.updateDeliveryCndCard(e)}>
          <div style={{ height: (window.innerHeight - 157) + 'px', overflow:'auto',marginBottom:'60px' }}>
            <Row>
            <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Delivery Location</FieldLabel>
                  <FieldInput
                    value={deliveryCndCard?.titan_extra_fields?.delivery_location || ''}
                    type={type}
                    keyParam="delivery_location"
                    updateField={this.updateForm}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Actual Delivery Date</FieldLabel>
                  <FieldDate
                    value={deliveryCndCard?.titan_extra_fields?.actual_delivery_date}
                    type={type}
                    keyParam="actual_delivery_date"
                    updateField={this.updateForm}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
            <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Delivery Comment</FieldLabel>
                  <FieldTextarea
                    value={deliveryCndCard?.titan_extra_fields?.delivery_comment || ''}
                    type={type}
                    keyParam="delivery_comment"
                    updateField={this.updateForm}
                    style={{height:'100px'}}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>
         </div>
         <div className="submit-block">
           <input type="submit" className="primary-btn" value="Save Changes"/>
           <Link onClick={() => this.props.toggleEditSideBar()} >Cancel</Link>
         </div>
       </form>
      )
  }
}
